<template>
  <div class="header" :class="[flag ? 'fixTop' : '']">
    <div class="nav">
      <div class="left">
        <div class="logo">
          <img src="../../../static/banner/logo.png" alt="">
          <!-- <img src="https://www.xaryxx.com/images/logo3.png" alt="" /> -->
        </div>
        <div class="nav-content">
          <div
            class="item"
            v-for="(item, index) in navList"
            :key="index"
            @click="opens(item, index)"
          >
            <div :class="current == index ? 'active' : ''">{{ item.name }}</div>
          </div>
        </div>
      </div>
      <!-- <div class="tell">
        <img src="https://www.xaryxx.com/images/tell.png" alt="">
        <span class="num">
          {{ info.phone }} </span>
      </div> -->
    </div>
    <!-- <div @click="contact" class="kefu">
      <img src="https://mk001.oss-cn-hangzhou.aliyuncs.com/app/21.gif" alt="">
      <div class="contact">联系客服</div>
    </div> -->
  </div>
</template>

<script>
import { companyInfo } from "@/api/api";
export default {
  name: "headerContent",
  data() {
    return {
      form: {},
      flag: false,
      dialogFormVisible: false,
      info: {},
      navList: [
        { name: "首页", path: "/" },
        { name: "案例", path: "/pages/case/index" },
        { name: "服务", path: "/pages/service/index" },
        { name: "新闻中心", path: "/pages/news/index" },
        { name: "关于我们", path: "/pages/contact/index" },
        // { name: "联系我们", path: "/pages/service/sub" },
      ],
      current: 0,
    };
  },

  watch: {
    $route: {
      handler: function (n, o) {
        if (n != o) {
          this.navList.filter((item, index) => {
            if (item.path == n.name) {
              this.current = index;
            }
          });
        }
      },
      // 深度观察监听
      deep: true,
      immediate: true,
    },
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.scrolling);
  },
  mounted() {
    this.getcompanyInfo();

    window.addEventListener("scroll", this.scrolling);
  },
  methods: {
    scrolling() {
      // // 滚动条距文档顶部的距离
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;

      // console.log(scrollTop,444444444)

      if (scrollTop > 600) {
        this.flag = true;
      } else {
        this.flag = false;
      }
      // // 滚动条滚动的距离
      // let scrollStep = scrollTop - this.oldScrollTop;
      // // console.log("header 滚动距离 ", scrollTop);
      // // 更新——滚动前，滚动条距文档顶部的距离
      // this.oldScrollTop = scrollTop;

      // //变量windowHeight是可视区的高度
      // let windowHeight =
      //   document.documentElement.clientHeight || document.body.clientHeight;
      // //变量scrollHeight是滚动条的总高度
      // let scrollHeight =
      //   document.documentElement.scrollHeight || document.body.scrollHeight;

      // //滚动条到底部的条件
      // if (scrollTop + windowHeight == scrollHeight) {
      //   //你想做的事情
      //   console.log("header  你已经到底部了");
      // }
      // if (scrollStep < 0) {
      //   this.flag = false
      //   console.log(scrollStep,"header 滚动条向上滚动了！");

      // } else {

      //   this.flag = true
      //   console.log(scrollStep,"header  滚动条向下滚动了！");
      // }
      // // 判断是否到了最顶部
      // if (scrollTop <= 0) {
      //   console.log("header 到了最顶部")
      // }
    },

    contact() {
      this.$router.push({ path: "/pages/service/sub" });
    },
    opens: function (params, index) {
      let self = this;
      // localStorage.setItem('current', index)
      self.$router.push({ path: params.path });
    },
    getcompanyInfo() {
      companyInfo().then((response) => {
        this.info = response.data;
      });
    },
  },
};
</script>

<style lang="less" scoped>
.kefu {
  position: fixed;
  bottom: 240px;
  right: 20px;
  box-shadow: 0 0 4px 2px #efefef;
  border-radius: 8px 8px 0 0;
  background: #fff;
  cursor: pointer;

  .contact {
    border-radius: 0 0 8px 8px;
    padding: 10px 0;
    text-align: center;
    font-size: 17px;
    font-weight: bold;
    box-shadow: 0 0 4px 2px #efefef;
  }

  img {
    display: block;
    width: 150px;
    height: 150px;
    background: #fff;
    // border-radius: 50%;
  }
}

.header {
  height: 120px;
  background: #ffffff;
  // border-radius: 9px 9px 9px 9px;
  // top: 53px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: fixed;
  left: 0;
  right: 0;
  z-index: 9;

  &.fixTop {
    height: 80px;
    background: rgba(255, 254, 254, 0.95);
    box-shadow: 2px 2px 8px #efefef;
    border-radius: 0;
    top: 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: fixed;
    left: 0;
    right: 0;
    z-index: 9;
    animation: addBG 0.5s;
  }

  @keyframes addBG {
    from {
      background: rgba(255, 254, 254, 0.55);
    }

    to {
      background: rgba(255, 254, 254, 0.95);
    }
  }

  .nav {
    padding-right: 40px;
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .left {
      display: flex;
      align-items: center;
      flex: 1;
    }

    .logo {
      // margin-right: 100px;
      margin: 15px 120px 15px 80px;

      img {
        display: block;
        width: 157.4px;
        // height: 50px;
      }

      // display: flex;
      // align-items: center;
      // margin: 0 0 0 40px;

      // img {
      //   display: block;
      //   width: 70px;
      //   height: 70px;
      // }
      // .name{
      //   margin-left: 10px;
      //   display: flex;
      //   flex-direction: column;
      //   height: 70px;
      //   >div:first-child{
      //     font-size: 30px;
      //     font-weight: bold;
      //     color: #b42002;
      //     margin: 5px 0;
      //   }
      //   >div:last-child{
      //     font-size: 16px;
      //     font-weight: bold;
      //     color: #eb9933;
      //   }
      // }
    }

    .nav-content {
      flex: 1;
      display: flex;
      .item {
        font-family: PingFang SC;
        font-weight: 400;
        font-size: 19px;
        color: #000000;
        line-height: 21px;
        padding-right: 74px;

        div {
          cursor: pointer;
        }

        .active {
          position: relative;
          color: #eb2300;
          font-family: PingFang SC;
          // font-weight: bold;
          font-size: 19px;
          color: #ff6019;
        }
      }
    }

    .tell {
      display: flex;
      align-items: center;
      padding: 0 28px;
      height: 44px;
      background: linear-gradient(90deg, #eb2300 0%, #ff5621 100%);
      border-radius: 76px 76px 76px 76px;
      opacity: 1;

      .num {
        font-size: 17px;
        font-family: PingFang SC-Regular, PingFang SC;
        font-weight: 400;
        color: #ffffff;
        line-height: 20px;
        padding-left: 5px;
      }
    }

    .search {
      flex: 0 1 9rem;
      height: 2rem;

      input {
        width: 7rem;
        line-height: 1rem;
        padding: 0.5rem 1rem;
        border-radius: 4.5rem;
        border-color: #cbcbcb;
        background-color: #ebebeb;
      }
    }
  }
}

@keyframes active {
  from {
    width: 0;
  }

  to {
    with: 5rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/headerContent.vue